import { useState } from 'react';
import { css } from '@emotion/react';
import type { Channel } from '@weave/schema-gen-ts/dist/schemas/integrations/sync-config-api/v1/message.pb';
import { ModalControlModalProps, Text } from '@frontend/design-system';
import { ActionModal, ActionModalContent } from '../shared/action-modal';
import { TrainPicker } from '../shared/train-picker';

interface ReplaceTrainModalProps {
  modalProps: ModalControlModalProps;
  channel?: Channel;
  isSaving?: boolean;
  onConfirm: (channelName: string, trainId: string) => void;
}

export const ReplaceTrainModal = ({ modalProps, isSaving, ...contentProps }: ReplaceTrainModalProps) => (
  <ActionModal modalProps={modalProps} isSaving={isSaving}>
    <ReplaceTrainModalContent {...contentProps} isSaving={isSaving} onClose={modalProps.onClose} />
  </ActionModal>
);

type ReplaceTrainModalContentProps = Omit<ReplaceTrainModalProps, 'modalProps'> & { onClose: () => void };

const ReplaceTrainModalContent = ({ channel, isSaving, onClose, onConfirm }: ReplaceTrainModalContentProps) => {
  const [selectedId, setSelectedId] = useState('');
  const currentTrainId = channel?.currentTrainId;
  const hasSelectedNewTrain = selectedId !== '' && selectedId !== currentTrainId;

  return (
    <ActionModalContent
      title={`Replace train on ${channel?.channelName ?? ''}`}
      onClose={onClose}
      isSaving={isSaving}
      confirmLabel='Replace'
      savingLabel='Replacing...'
      confirmDisabled={!channel || !hasSelectedNewTrain}
      onConfirm={() => channel && onConfirm(channel.channelName ?? '', selectedId)}
    >
      {channel && (
        <>
          <div css={summaryRowStyle}>
            <Text weight='bold'>Current train :</Text>
            <Text>{channel.currentTrainId}</Text>
          </div>
          <TrainPicker
            label='Replace with'
            name='train-search'
            selectedId={selectedId}
            onSelect={setSelectedId}
            disabled={isSaving}
            currentTrainId={currentTrainId}
          />
        </>
      )}
    </ActionModalContent>
  );
};

const summaryRowStyle = css`
  display: flex;
  gap: var(--fabric-space-gap-xs);
  align-items: baseline;
`;
